
//TODO : 
// date format
// refresh

import React from 'react';
import Moment from 'react-moment';
import { CardMedium } from '../../widgets/Cards';
//import Modal from '../../widgets/Modal';
//import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
//import { Form, Field} from 'react-final-form';

import { fetchPrescriptions, fetchPrescription, editPrescription, newPrescription, deletePrescription} from '../../../actions';

class Prescription extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDelete : false,
            newForm : true,
            record : null,
        };
    };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchPrescriptions(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchPrescriptions(this.props.patient._id)
        }   
    }

    // sorting data by date
    compareDate(a, b) {

        var key1 = a.date;
        var key2 = b.date;
    
        if (key1 > key2) {
            return -1;
        } else if (key1 === key2) {
            return 0;
        } else {
            return 1;
        }
    }

    renderPrescriptionList() {

        var list = this.props.prescriptions;
        var sortedList = list.sort(this.compareDate);

        return sortedList.map(prescription =>  {
         
          
                return (
                        <tr key={prescription._id}>
                            <td>{prescription.product}</td>
                            <td>{prescription.dose}</td>
                            <td>{prescription.frequency}</td>
                            <td>{prescription.quantity}</td>
                            <td>{prescription.repeat}</td>
                            <td>{prescription.authority}</td>
                            <td>{prescription.approval}</td>
                            <td>{prescription.reg24}</td>
                            <td>{prescription.provider}</td>
                            <td><Moment format='DD MMM YYYY'>{prescription.date}</Moment></td>
                            <td>{prescription.privacy}</td>
                        </tr>
                        )
        })
    }

    render() {
        return (
            <CardMedium title='Prescriptions' >
                <table>
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Dose</th>
                            <th>Frequency</th>
                            <th>Qty</th>
                            <th>Repeat</th>
                            <th>Authority</th>
                            <th>Approval</th>
                            <th>Reg24</th>
                            <th>Prescriber</th>
                            <th>Date</th>
                            <th>Privacy</th>
                        </tr>
                    </thead>
                    <tbody> 
                        {this.renderPrescriptionList()}
                    </tbody> 
                </table>
            </CardMedium>
        )
    }

}

const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        prescriptions : Object.values(state.prescriptions),
        userId : state.auth.userId,
        selectedPrescription : state.selectedPrescription
    }
}

export default connect(mapStateToProps, {fetchPrescriptions, fetchPrescription, editPrescription, newPrescription, deletePrescription})(Prescription);










    








